import { render, staticRenderFns } from "./new_H_Com.vue?vue&type=template&id=01a8ee92"
import script from "./new_H_Com.vue?vue&type=script&lang=js"
export * from "./new_H_Com.vue?vue&type=script&lang=js"
import style0 from "./new_H_Com.vue?vue&type=style&index=0&id=01a8ee92&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports